import { html, View } from 'rune-ts';
import klass from './CreatorEmptyScreen.module.scss';
import { typo } from '../../../../shared/typography/typo';

export interface CreatorEmptyScreenData {
  image_src?: string;
  title?: string;
  body?: string;
}

interface CreatorEmptyScreenOption {
  klass?: string;
}

export class CreatorEmptyScreen extends View<CreatorEmptyScreenData> {
  state: CreatorEmptyScreenOption & {
    // FIXME
  };

  constructor(data: CreatorEmptyScreenData, option: CreatorEmptyScreenOption = {}) {
    super(data);

    const empty_title = data.title || ET('mps2::creator::empty_title');

    this.data.title = empty_title;
    this.data.image_src =
      data.image_src ||
      '//s3.marpple.co/files/u_218933/2024/6/original/24d3d1e5efb5efbb45b74df4f6be882177f881a61.png';
    this.data.body = data.body || 'Plus Shop';

    this.state = {
      klass: option.klass,
    };
  }

  override template() {
    return html`<div class="${klass.creator_empty} ${this.state.klass}">
      <div class="${klass.image}"><img class=${klass.img} src="${this.data.image_src}" alt="" /></div>
      <div class="${klass.title} ${typo('20_bold')}">${this.data.title}</div>
      <div class="${klass.body} ${typo('16_medium')}">
        ${html`${this.data.body}만의 크리에이터들이<br />찾아올 예정이에요!`}
      </div>
    </div>`;
  }
}
